class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    //check if dossier protection is in cart and remove's it
    removeNavidium();
    window.autoOpenFreeProductModal?.();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, isFromBundleBuilder, productsIdList) {

    console.log('rased state', parsedState)

    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;


    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

      // console.log('curent section', sectionElement.innerHTML)
      // if (parsedState.sections[section.id].includes('drawer__cart-items-wrapper')) {

      //   console.log("parsed secrtion", parsedState.sections[section.id])
      // }
    });

    if (window.innerWidth < 991 && document.querySelector('.atc-notification-modal') && !(window.location.href.includes('cart'))) {
      // if (productsIdList && productsIdList.length > 1) {
      //   //get data and update modal
      //   let itemsContainer = document.querySelector('.atc-notification-modal__items');

      //   itemsContainer.innerHTML = ``;

      //   parsedState.items.forEach(item => {
      //     itemsContainer.innerHTML += `
      //     <div class="atc-notification-modal__item-wrapper">
      //       <div class="item-image"><img src="${item.featured_image.url}" alt=""></div>
      //       <div class="item-main-details">
      //         <p class="item-title">${item.title}</p>
      //         <p class="item-price">MXN${(item.final_price / 100).toFixed(2)}</p>
      //       </div>
      //       <div class="item-extra-details">
      //         <p>Eau de Parfum. Tamaño: 50ml / 1.7oz</p>
      //         <p>
      //           ${item.vendor}
      //           <ds-button><button class="button__disclaimer text-color--coral" type="button" data-modal-target="#product-disclaimer-modal"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M5.47113 9.87597C5.16718 9.87597 4.91389 9.81518 4.71125 9.69359C4.50862 9.55175 4.42756 9.36938 4.46809 9.14648L4.95441 5.98539L4.86323 5.9246L2.34044 7.96107C2.23912 8.02186 2.1378 8.05226 2.03648 8.05226C1.71227 8.05226 1.43871 7.83949 1.21582 7.41396C1.05371 7.13027 0.972656 6.88711 0.972656 6.68448C0.972656 6.44132 1.0841 6.26908 1.307 6.16776L4.31612 4.98235V4.89117L1.3374 3.70576C1.09424 3.60444 0.972656 3.4322 0.972656 3.18904C0.972656 2.96615 1.05371 2.72299 1.21582 2.45956C1.31713 2.25693 1.43871 2.09482 1.58056 1.97324C1.7224 1.85166 1.86425 1.79087 2.00609 1.79087C2.10741 1.79087 2.21886 1.8314 2.34044 1.91245L4.89362 3.94892L4.95441 3.88813L4.46809 0.696646C4.44783 0.473749 4.52888 0.30151 4.71125 0.17993C4.91389 0.0583492 5.16718 -0.00244141 5.47113 -0.00244141C5.81561 -0.00244141 6.07903 0.0583492 6.2614 0.17993C6.46404 0.30151 6.54509 0.473749 6.50456 0.696646L6.04864 3.91853L6.10943 3.97932L8.66262 1.91245C8.78419 1.8314 8.88551 1.79087 8.96657 1.79087C9.10841 1.79087 9.25025 1.85166 9.3921 1.97324C9.53394 2.09482 9.65552 2.25693 9.75684 2.45956C9.91895 2.72299 10 2.96615 10 3.18904C10 3.45247 9.88855 3.62471 9.66565 3.70576L6.62614 4.92157V4.98235L9.66565 6.16776C9.88855 6.24882 10 6.41092 10 6.65409C10 6.87698 9.91895 7.13027 9.75684 7.41396C9.51368 7.83949 9.25025 8.05226 8.96657 8.05226C8.84499 8.05226 8.74367 8.01173 8.66262 7.93068L6.10943 5.9246L6.04864 5.955L6.50456 9.14648C6.54509 9.36938 6.46404 9.55175 6.2614 9.69359C6.07903 9.81518 5.81561 9.87597 5.47113 9.87597Z" fill="#EF776A"/></svg></button></ds-button>
      //         </p>
      //       </div>
      //     </div>
      //     `
      //   })
      // } else {
      //   let itemsContainer = document.querySelector('.atc-notification-modal__items');

      //   let currentProduct = {
      //     id: productsIdList[0],
      //     img_src: document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__image`)?.src,
      //     title: document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__name`)?.textContent,
      //     price: document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__price-wrapper .cart-item__old-price`) ? document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__price-wrapper .cart-item__old-price`)?.textContent : document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__price-wrapper .price`)?.textContent,
      //     new_price: document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__price-wrapper .cart-item__new-price`) ? document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__price-wrapper .cart-item__new-price`)?.textContent : '',
      //     inspired_by: document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"]  .cart-item__details-extra`)?.innerHTML,
      //   }

      //   itemsContainer.innerHTML = ``;

      //   itemsContainer.innerHTML = `
      //     <div class="atc-notification-modal__item-wrapper">
      //       <div class="item-image"><img src="${currentProduct.img_src}" alt=""></div>
      //       <div class="item-main-details">
      //         <p class="item-title">${currentProduct.title}</p>
      //         ${
      //           currentProduct.new_price
      //             ? `<p class="item-price item-price__sale">${currentProduct.new_price}</p>
      //               <p class="item-price item-price__regular">${currentProduct.price}</p>`
      //             : `<p class="item-price">${currentProduct.price}</p>`
      //         }
      //       </div>
      //       <div class="item-extra-details">
      //         ${currentProduct.inspired_by}
      //       </div>
      //     </div>
      //   `;
      // }

      // //qty calc

      // let qty = document.querySelector('[data-cart-qty]').dataset.cartQty;
      // let pills = document.querySelectorAll('.atc-notification-modal__progress-bar-wrapper .progress-bar__content .progress');

      // pills.forEach((pill, index) => {
      //   if (index < qty) {
      //     pill.classList.add('active');
      //   }
      //   else {
      //     pill.classList.remove('active');
      //   }
      // });

      //open atc modal
      if (document.querySelector('.drawer:not(.active)')) {

        if (!document.querySelector(".cart-free-product_container--main_product .cart-item") && document.querySelector("body.crmOfferON")) {
          document.querySelector('#free-product-modal-gift').classList.toggle('show');
        }
        else {
          document.querySelector('.atc-notification-modal').show();

          document.body.classList.add('overflow-hidden');
          document.querySelector('.atc-notification-modal').classList.remove('animate-slideToBottomPopup');
          document.querySelector('.atc-notification-modal').classList.add('animate-slideFromBottomPopup');


          //close after 4 seconds
          setTimeout(() => {
            document.querySelector('.atc-notification-modal').classList.remove('animate-slideFromBottomPopup');
            document.querySelector('.atc-notification-modal').classList.add('animate-slideToBottomPopup');
            document.body.classList.remove('overflow-hidden');
          }, 3500)
          setTimeout(() => {
            document.querySelector('.atc-notification-modal:has(.small-version)').close();
          }, 4000);
        }

      }
    }
    else {
      if (isFromBundleBuilder) {
        setTimeout(() => {
          this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        });
      } else {
        setTimeout(() => {
          this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
          if (!window.location.href.includes('/cart')) {
            this.open();
          }
        });
      }
    }
    // 1. Dynamic updates -- AFTER CART IS RENDERED
    //----------------------------------------------------------------
    updateAnnouncementBar();
    updateCartCountBubbleBottomIsland();
    updatePreviouslyViewedProducts();
    cartLimitReached();
    showDynamicPrices();

    // autoOpenFreeProductModal();

    if (window.location.pathname.split("/").at(-1) == 'bundle') {
      updateBundleBuilder();
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
      // {
      //   id: 'main-cart-items',
      //   selector: '.js-contents'
      // }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      // {
      //   id: 'main-cart-items',
      //   section: 'main-cart-items',
      //   selector: '.js-contents'
      // }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
